import { render, staticRenderFns } from "./leftPanel.vue?vue&type=template&id=56f1e7b0"
import script from "./leftPanel.vue?vue&type=script&lang=js"
export * from "./leftPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports